module.exports = __webpack_public_path__ + "img/V400Icon.a115ba61.png";